import RequestDetail from './RequestDetail';

/**
 * A page component that renders the request detail view.
 * 
 * This component serves as a wrapper for the RequestDetail component,
 * providing the main page structure for displaying detailed information
 * about a specific request.
 * 
 * @returns The rendered request detail page component
 */
export default function RequestDetailPage() {
  return <RequestDetail />;
}